module.exports = __webpack_public_path__ + "static/media/cocktailFive.e23e31dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/cocktailFive.png
// module id = 323
// module chunks = 0